import { usePageTitle } from '../../hooks/usePageTitle';
import { useProductPricesSub } from '../../hooks/useProductPricesSub';
import { ProductType } from '../../hooks/useProducts';
import { formatDollar } from '../../lib/formatters';
import { getDecimalPlaces } from '../../lib/math';

type TradePageDocumentTitleProps = {
  product: ProductType;
};

export function TradePageDocumentTitle({ product }: TradePageDocumentTitleProps) {
  const { data: pricesByProductId } = useProductPricesSub();

  const { midPrice } = pricesByProductId[product.id] || {};
  const priceDecimals = getDecimalPlaces(product.tickSize);

  usePageTitle(
    midPrice
      ? `${formatDollar(midPrice, {
          minimumFractionDigits: priceDecimals,
          maximumFractionDigits: priceDecimals,
        })} | ${product.baseTokenName}`
      : product.baseTokenName
  );

  return null;
}
